import React from 'react';
import { SessoesProps } from './sessoes-props';
import { Sessao } from 'modulos/cardapio/componentes/produtos/sessao';
import { SessoesInstancia } from './sessoes-instancia';
import { useSessoes } from './use-sessoes';
import { ProdutoCategoriaModel } from 'api/cardapio/models/produto/produto-categoria-model';
import { retiraAcentos } from 'utils/retirar-acentos';

export const Sessoes = React.forwardRef<SessoesInstancia, SessoesProps>((props, ref) => {
  const { dados, operacoes } = useSessoes(props);

  const {
    className,
    sessoes,
    carregando,
    quandoSessaoForVisualizada,
    deletar,
    adicionarProdutoClick,
    onProdutoClick,
  } = props;

  React.useImperativeHandle(ref, () => ({
    pesquisarSessoes: operacoes.pesquisarSessoes,
    rolarParaSessao: operacoes.rolarParaSessao,
    sessaoStateChanged: sessaoStateChanged,
  }));

  const catOrdenadas = (sessoes || []).sort(function (a, b) {
    if (retiraAcentos(a.nome || '').toLowerCase() < retiraAcentos(b.nome || '').toLowerCase()) return -1;
    if (retiraAcentos(a.nome || '').toLowerCase() > retiraAcentos(b.nome || '').toLowerCase()) return 1;
    return 0;
  });

  const [filtroSessoes, setFiltroSessoes] = React.useState(Array.from(new Array(1)));

  React.useEffect(() => {
    let sessoesArr = catOrdenadas
    setFiltroSessoes(sessoesArr);

  }, [catOrdenadas, sessoes]);

  const sessaoStateChanged = (categoriaId?: string) => {
    let refArray = filtroSessoes;
    let item = refArray.find((x) => x.categoriaId === categoriaId) || { ativo: false };
    item.ativo = !item.ativo;

    setFiltroSessoes(refArray);
  };
  if (filtroSessoes !== undefined && filtroSessoes.length > 1) {
  }
  const produtos = (filtroSessoes as ProdutoCategoriaModel[])?.map(x => {
    return x?.produtos.map(y => {
      return {
        ...y,
        categoriaDescricao: x.nome,
      }
    })
  }).reduce((resultado, valorAtual) => {
    return resultado.concat(valorAtual);
  }, [])

  return (
    <div className={className}>
      <div>
        <Sessao
          sessoesRef={dados.sessoesRef}
          sessaoDeBusca={false}
          carregando={carregando}
          produtos={produtos}
          sessoes={sessoes}
          deletar={deletar}
          quandoForVisualizada={quandoSessaoForVisualizada}
          adicionarProdutoClick={adicionarProdutoClick}
          onProdutoClick={onProdutoClick}
        />
      </div>
    </div>
  );
});

Sessoes.displayName = 'Sessoes';